import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '../../atoms/PrimaryButton'
import CommonContext from '../../../context/common/commonContext'

const Maintainance = () => {
    const history = useHistory()
    const { phrase } = useContext(CommonContext)
    const leaveMaintainacePage = () => {
        global.maintainance_mode = false
        history.push('/')
    }
    return (
        <div style={{ height: '600px', marginTop: '100px' }}>
            <h1>{phrase['api_disabled'] || 'API Disabled'}</h1>
            <p>
                {phrase['service_currently_unavailable'] ||
                    'The service is currently unavailable. Please contact the administrator.'}
            </p>
            <PrimaryButton
                btnSize="small"
                label={phrase['ok'] || 'Ok'}
                width="50px"
                onClick={() => leaveMaintainacePage()}
            />
        </div>
    )
}

export default Maintainance
